import { AnalyticsEvent } from './BaseAnalyticsEvent';
import { type AnalyticsEventName } from './types/AnalyticsEventName';

export class FileDownloadEvent extends AnalyticsEvent<AnalyticsEventName.FILE_DOWNLOAD> {
  constructor(public data: { name: string; url: string; title: string }) {
    super('analytics.download');
  }
}
